import classNames from 'classnames';

import styles from './_index.module.scss';

export interface ToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  tools: React.ReactNode[];
}

const Toolbar = ({ children, className, tools, ...props }: ToolbarProps) => {
  return (
    <div className={classNames(styles['toolbar'], className)} {...props}>
      <div>{children}</div>
      {tools.length > 0 && (
        <ul className={styles['toolbar-tools']}>
          {tools.map((tool, index) => (
            <li key={index}>{tool}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Toolbar;
